/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_TitleInputs */

const zh_billing_title = /** @type {(inputs: Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账单管理`)
};

const en_billing_title = /** @type {(inputs: Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing Management`)
};

const es_billing_title = /** @type {(inputs: Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de facturación`)
};

/**
* | output |
* | --- |
* | "Billing Management" |
*
* @param {Billing_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const billing_title = /** @type {((inputs?: Billing_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_title(inputs)
	if (locale === "en") return en_billing_title(inputs)
	return es_billing_title(inputs)
});